import { api } from "./api";

export async function fetchAdminResumen() {
  const { data } = await api.get("/admin/resumen");
  return data;
}

export async function fetchAdminPagos(limite = 30) {
  const { data } = await api.get("/admin/pagos", { params: { limite } });
  return data.items || [];
}

export async function fetchAdminSuscripciones() {
  const { data } = await api.get("/admin/suscripciones");
  return data.items || [];
}

export async function fetchAdminDestacados() {
  const { data } = await api.get("/admin/destacados");
  return data.items || [];
}


export async function fetchAdminUsuarios(params = {}) {
  const { data } = await api.get("/admin/usuarios", { params });
  return data;
}

export async function fetchAdminUsuarioDetalle(userId) {
  const { data } = await api.get(`/admin/usuarios/${userId}`);
  return data;
}

export async function suspenderUsuario(userId, motivo) {
  const { data } = await api.post(`/admin/usuarios/${userId}/suspender`, { motivo });
  return data;
}

export async function reactivarUsuario(userId, motivo) {
  const { data } = await api.post(`/admin/usuarios/${userId}/reactivar`, { motivo });
  return data;
}

export async function anonimizarUsuario(userId, motivo) {
  const { data } = await api.post(`/admin/usuarios/${userId}/anonimizar`, { motivo });
  return data;
}

export async function eliminarUsuario(userId, motivo) {
  const { data } = await api.delete(`/admin/usuarios/${userId}`, { params: { motivo } });
  return data;
}

export async function fetchAdminAuditoria(limite = 50) {
  const { data } = await api.get("/admin/usuarios-auditoria", { params: { limite } });
  return data.items || [];
}

export async function fetchAdminWebhooks(params = {}) {
  const { data } = await api.get("/admin/webhooks", { params });
  return data;
}
